var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"template-view-container"},[_c('TemplatesBrowser'),_c('TemplatesSidebar')],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }